<template>
	<router-view :key="$route.fullPath" />
</template>

<script>
	import { storage } from '@/services/storage'

	export default {
		beforeRouteEnter(to, from, next) {
			const allowedApps = storage.get('allowed_apps')
			if (!allowedApps.includes('launchday')) {
				next(vm => {
					vm.$toastr.e('Este recurso não está ativo. Para contratar este módulo '
						+ 'entre em contato com o nosso departamento de vendas.')
					next('/')
				})

			} else {
				next()
			}
		}
	}
</script>

<style>

</style>